import React, { Component } from "react";
import { connect } from "react-redux";
import EditUser from "../Form/EditForm";
import ReactTableComponent from "../tables/ReactTable";
//import MoreVertIcon from "@material-ui/icons/MoreVert";
import Active from "../assets/Active.png";
import Inactive from "../assets/Inactive.png";
import Delete from "../assets/delete.png";
import Edit from "../assets/edit.png";

import {
  TextField,
  MenuItem,
  Button,
  Drawer,
  Checkbox,
  FormControlLabel,
  //IconButton,
  Menu,
  //Select
} from "@material-ui/core";

import SearchIcon from "../assets/search.png";
import NextArrow from "../assets/next-arrow.png";
import AddUser from "../Form/AddNewForm";

import {
  addUsersForm,
  getData,
  usersValidation,
  editUsersValidation,
  editUsersForm
} from "./UsersConfig";
import { addorEditUser, updateUser, updatePassword } from "./Userquery";
import "./Users.css";
import swal from "sweetalert";
import { fetchMethod } from "../../FetchMethod";
import { CustomerInfo, userSearch } from "../../Queries";

//const label = { inputProps: { "aria-label": "Checkbox demo" } };
//const InacValue = 0;
class Users extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      status2: null,
      status3: null,
      loading: false,
      right: false,
      right1: false,
      header: "User Management",
      users: [],
      allUsers: [],
      editData: [],
      Row: [],
      totalCount: 0,
      limit: 50,
      offset: 50,
      searchFlag: false,
      clickToSearch: false,
      customerData: [],
      customerData1: [],
      filterColumn: "",
      shortfilter: false,
      userExportData: [],
      anchorEl2: false,

      anchorEl: null,
      selectedUserRow: null
    };
  }

  componentDidMount() {
    localStorage.setItem("path", "/Users");
    this.userCustomer();
    this.props.onHandleCampaign();
    this.props.onHandleSidebarText("/Users");
  }

  userCustomer = () => {
    const filter1 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              active: 1,
              createdby: localStorage.getItem("id"),
              order: "company asc"
            }
          }
        : {
            where: {
              active: 1,
              order: "company asc"
            }
          };
    fetchMethod(CustomerInfo, filter1)
      .then(response => {
        return response.json();
      })
      .then(res => {
        let data =
          res.data !== undefined &&
          res.data.allCustomers !== undefined &&
          res.data.allCustomers !== null
            ? res.data.allCustomers.Customers
            : "";

        this.setState({
          loading: false,
          customerData: data
        });
      })
      .catch(e => console.log(e));
    const filter2 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id"),
              order: "company asc"
            }
          }
        : {
            where: {
              order: "company asc"
            }
          };
    fetchMethod(CustomerInfo, filter2)
      .then(response => {
        return response.json();
      })
      .then(res => {
        let data =
          res.data !== undefined &&
          res.data.allCustomers !== undefined &&
          res.data.allCustomers !== null
            ? res.data.allCustomers.Customers
            : "";

        this.setState({
          loading: false,
          customerData1: data
        });
      })
      .catch(e => console.log(e));
  };

  toggleDrawer = (side, open, user) => async event => {
    this.handleMenuClose();

    if (user !== undefined) {
      this.setState({ Row: user });
      let data = await getData(user.id);
      this.setState({ editData: data.data.allUsersdata.Usersdata[0] });

      if (
        event &&
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      this.setState({ ...this.state, [side]: open });
    } else {
      if (
        event &&
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      this.setState({ ...this.state, [side]: open });
      localStorage.removeItem("type");
    }
  };

  handleSearchChange = event => {
    this.setState({ search: event.target.value }, () => {
      if (this.state.search !== "") {
        this.setState(
          {
            searchFlag: true
          },
          () => {
            this.onSearchClick();
          }
        );
      } else {
        this.setState(
          {
            searchFlag: false
          },
          () => {
            this.onSearchClick();
          }
        );
      }
    });
  };

  debounceTimer = null;
  onSearchClick = searchFlag => {
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      },
      200
    );
    searchFlag || this.state.searchFlag
      ? this.setState({ clickToSearch: true }, () => {})
      : this.setState({ clickToSearch: false }, () => {
          this.child.current.searchFetch(this.state.limit, this.state.offset);
        });
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };

  onStatusChange = event => {
    var checkvalue = 1;
    var checkStatus = null;
    if (event.target.checked === false) {
      checkStatus = 0;
    } else {
      checkStatus = 1;
    }
    if (
      event.target.checked === false &&
      (this.state.status2 === 1 || this.state.status2 == null)
    ) {
      checkvalue = "All";
    }

    if (event.target.checked === true && this.state.status2 === 0) {
      checkvalue = "All";
    }
    if (event.target.checked === false && this.state.status2 === 0) {
      checkvalue = 0;
    }

    this.setState(
      {
        status3: checkStatus,
        status: checkvalue,
        clickToSearch: false
      },
      () => {
        this.onSearchClick();
      }
    );
  };
  onStatusChange2 = event => {
    var checkvalue = 0;
    var checkStatus = null;
    if (event.target.checked === false) {
      checkStatus = 1;
    } else {
      checkStatus = 0;
    }

    if (
      event.target.checked === false &&
      (this.state.status3 === 0 || this.state.status3 == null)
    ) {
      checkvalue = "All";
    }

    if (event.target.checked === true && this.state.status3 === 1) {
      checkvalue = "All";
    }
    if (event.target.checked === false && this.state.status3 === 1) {
      checkvalue = 1;
    }
    this.setState(
      {
        status2: checkStatus,
        status: checkvalue,
        clickToSearch: false
      },
      () => {
        this.onSearchClick();
      }
    );
  };

  setListData = response => {
    this.setState({
      users: response.data.all.Usersdata,
      totalCount: response.data.all.totalCount
    });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  handleMenuOpen = event => {
    this.setState({ anchorEl2: true, userData: event });
  };
  handleMenuClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  showUserToPopup = (e, row) => {
    this.setState({
      selectedUserRow: {
        ...row.original
      },
      anchorEl: e.currentTarget,
      clientY: e.clientY,
       clientX: e.clientX
    });
  };

  ActionMenu = () => {
    return (
      <div>
        <Menu
          id="statusMenu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          keepMounted
          style={{
            top:
              this.state.clientY < 100
                ? `${this.state.clientY}px`
                : `${this.state.clientY - 20}px`,
                 left: this.state.clientX
         
          }}
          onClose={this.handleMenuClose}
        >
          <MenuItem
            onClick={this.toggleDrawer(
              "right1",
              true,
              this.state.selectedUserRow
            )}
          >
            <img src={Edit} alt="Delete" className="deleteButton" />
            {"   "}
            Edit
          </MenuItem>
          <MenuItem onClick={() => this.onDelete(this.state.selectedUserRow)}>
            <img src={Delete} alt="Delete" className="deleteButton" />
            {"   "}
            Inactive{" "}
          </MenuItem>
        </Menu>
      </div>
    );
  };

  onDelete = user => {
    this.handleMenuClose();
    if (user.status === 1 || user.status === "1") {
      swal({
        title: "Are you sure you want to make this user inactive?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          const test = {
            id: { id: user.id },
            data: { status: 0 }
          };

          fetchMethod(updateUser, test)
            .then(response => {
              return response.json();
            })
            .then(res => {
              this.setState(
                {
                  loading: false
                },
                () => {
                  this.child.current.searchFetch(
                    this.state.limit,
                    this.state.offset
                  );
                }
              );
            })
            .catch(e => console.log(e));
        }
      });
    }
  };

  NameFilter = () => {
    this.setState({ filterColumn: "firstName asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ filterColumn: "firstName desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  RoleFilter = () => {
    this.setState({ filterColumn: "role asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  RoleFilter1 = () => {
    this.setState({ filterColumn: "role desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  StatusFilter = () => {
    this.setState({ filterColumn: "status asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  StatusFilter1 = () => {
    this.setState({ filterColumn: "status desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  AbmFilter = () => {
    this.setState({ filterColumn: "abm asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  AbmFilter1 = () => {
    this.setState({ filterColumn: "abm desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  setUsersRowClick = rowInfo => {};
  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };

  render() {
    let { status, totalCount, clickToSearch, search } = this.state;
    let Search = clickToSearch ? search.trim().replace(/\s\s+/g, "") : "";
    Search = Search.split(" ");
    const like1 = "%" + `${Search[0]}` + "%";
    const like2 = "%" + `${Search[1]}` + "%";

    let filt = {
      or: [
        { firstName: { like: like1, options: "i" } },
        { lastName: { like: like2, options: "i" } },
        { contactnumber: { like: like1, options: "i" } },
        { role: { like: like1, options: "i" } },
        { email: { like: like1, options: "i" } },
        { lastName: { like: like1, options: "i" } }
      ]
    };
    let filter =
      localStorage.getItem("role") === "ADMIN"
        ? status === "All"
          ? {
              where: {
                order: this.state.filterColumn,
                createdby: localStorage.getItem("id"),
                and: [filt]
              }
            }
          : {
              where: {
                createdby: localStorage.getItem("id"),
                order: this.state.filterColumn,
                status: status,
                and: [filt]
              }
            }
        : status === "All"
        ? { where: { order: this.state.filterColumn, and: [filt] } }
        : {
            where: {
              order: this.state.filterColumn,
              status: status,
              and: [filt]
            }
          };

    let data = [...this.state.users];
    const Theaders = [
      {
        Header: obj => {
          const { selectedEngagedRow } = this.state;
          return (
            <div className="Nameclass">
              <div
                className="Name"
                style={{ cursor: "pointer" }}
                onClick={
                  this.state.shortfilter !== true
                    ? this.NameFilter
                    : this.NameFilter1
                }
              >
                Name
              </div>
            </div>
          );
        },
        accessor: "Name"
      },
      {
        Header: "Email address",
        accessor: "email"
      },
      {
        Header: "Phone number",
        accessor: "contactnumber"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.RoleFilter
                  : this.RoleFilter1
              }
            >
              Role
            </div>
          );
        },
        accessor: "Role"
      },
            {
        Header: (obj) => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.StatusFilter
                  : this.StatusFilter1
              }
            >
              Status
            </div>
          );
        },
        accessor: "Status",
      },
      {
        Header: (obj) => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.AbmFilter
                  : this.AbmFilter1
              }
            >
              ABM
            </div>
          );
        },
        accessor: "Abm",
      },

   
    ];
        const homeActions = [
      {
        Header: "Action",
        Cell: (row) => (
          <div className="iconButton">
            <a onClick={this.toggleDrawer("right1", true, row.original)}>
              <img
                src={Edit}
                alt="Edit"
                className="editButton"
                width="20px"
                title="Edit"
              />
            </a>
            <a
              className="iconDelete"
              onClick={() => this.onDelete(row.original)}
            >
              <img
                src={Delete}
                alt="Delete"
                className="deleteButton"
                title="Deactivate"
              />
            </a>
          </div>
        ),
      },
    ];

    data.map(user => {
      let fname =
        user.firstName !== undefined && user.firstName !== null
          ? user.firstName
          : "";
      let lname =
        user.lastName !== undefined && user.lastName !== null
          ? user.lastName
          : "";

      user.Name = fname + " " + lname;

      user.Role =
        user.role === "CAMPAIGNMANAGER"
          ? "Campaign Manager"
          : user.role === "CUSTOMER"
          ? "Customer"
          : user.role === "SADMIN"
          ? "S Admin"
          : "Admin";
 
            user.status === 1
        ? (user.Status = (
            <img
              src={Active}
              alt="Active"
              title="Active"
              style={{ width: "20px" }}
            />
          ))
        : user.status === 0
        ? (user.Status = (
            <img
              src={Inactive}
              alt="Inactive"
              title="Inactive"
              style={{ width: "20px" }}
            />
          ))
        : (user.Status = user.Status);

        user.abm === 1
        ? (user.Abm = (

        //   <FiberManualRecordIcon
        //   checked={user.Abm == 1 ? true : false}
        //   // onChange={handleChange}
        //   name="checkedA"
        // />
            <img
              src={Active}
              alt="Active"
              title="Active"
              style={{ width: "20px" }}
            />
          ))
        : user.abm === 0
        ? (user.Abm = (
            <img
              src={Inactive}
              alt="Inactive"
              title="Inactive"
              style={{ width: "20px" }}
            />
          ))
        : (user.Abm = user.Abm);
        
    });

    return (
      <div className="Users">
        <div className="top-flexbox">
          <div className="title-block">
            <h1>Users</h1>
            <p>
              Total <span>{this.state.totalCount}</span> Records
            </p>
          </div>
          <div className="button-block">
            <Button
              variant="outlined"
              color="primary"
              onClick={this.toggleDrawer("right", true)}
              className="addButton"
            >
              A<span style={{ textTransform: "lowercase" }}>dd</span> &nbsp;N
              <span style={{ textTransform: "lowercase" }}>ew</span>
            </Button>
          </div>
        </div>
        <div className="modalButton-flex">
          <div className="statusSearchDiv">
            <div className="searchTextField">
              <TextField
                id="outlined-search"
                label="Search"
                type="text"
                margin="normal"
                variant="outlined"
                onKeyDown={this.onSearchKeyDown}
                placeholder="Name/email/role/phone..."
                value={this.state.search}
                onChange={this.handleSearchChange}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      alt=""
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>
            <div className="checkbox-block">
              <FormControlLabel
                control={<Checkbox />}
                label="Active"
                onChange={this.onStatusChange}
                InputProps={{
                  endAdornment: (
                    <img src={NextArrow} alt="" style={{ width: "7px" }} />
                  )
                }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Inactive"
                onChange={this.onStatusChange2}
                InputProps={{
                  endAdornment: (
                    <img src={NextArrow} alt="" style={{ width: "7px" }} />
                  )
                }}
              />
            </div>
          </div>

          <Drawer anchor="right" open={this.state.right}>
            <AddUser
              title="Add User"
              formConfig={addUsersForm}
              modalClose={this.toggleDrawer("right", false)}
              formValidation={usersValidation}
              query={addorEditUser}
              params={this.state.customerData}
              className={"userForm"}
              buttonName="Save"
              message="New User added successfully"
              updateData={() =>
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                )
              }
            />
          </Drawer>
        </div>
        <Drawer anchor="right" open={this.state.right1}>
          <EditUser
            title="Edit User"
            formConfig={editUsersForm}
            editableData={this.state.editData}
            params={this.state.customerData1}
            formValidation={editUsersValidation}
            modalClose={this.toggleDrawer("right1", false, this.state.Row)}
            className="userForm"
            buttonName={"Update"}
            query={updateUser}
            query2={updatePassword}
            message="User updated successfully"
            updateData={() =>
              this.child.current.searchFetch(
                this.state.limit,
                this.state.offset
              )
            }
          />
        </Drawer>
        {this.ActionMenu()}

        <ReactTableComponent
          ref={this.child}
          listData={data}
          listConfig={Theaders.concat(homeActions)}
          setData={this.setListData}
          query={userSearch}
          totalCount={totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filter}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.setUsersRowClick}
        />
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    onHandleSidebarText: data =>
      dispatch({
        type: "HANDLE_SIDEBAR_TEXT",
        payload: data
      }),
    onHandleCampaign: data =>
      dispatch({ type: "Campaign_Detail", payload: null })
  };
};

export default connect(null, mapDispatchToProps)(Users);
